import { Inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CaptchaDetailModel } from '../../models';
import { CustomizedHttpService } from '../base/customized-http.service';

@Injectable({
  providedIn: 'root'
})
export class OtherDetailService {

  constructor(private httpService: CustomizedHttpService, @Inject('BASE_URL') private originUrl: string) { }

  getCaptchaDetail(): Observable<CaptchaDetailModel> {
    return this.httpService.getByQuery<CaptchaDetailModel>(`${this.originUrl}otherDetail/getCaptchaDetail`, new HttpParams());
  }

  validateCaptchaToken(token: string) {
    return this.httpService.post<any, any>(`${this.originUrl}tracker/validateCaptchaToken`, { token: token });
  }
}
